(function () {
  const stickyScrollEffect = () => {
    document.querySelectorAll(".sticky-section").forEach((block) => {
      const box = block.closest("section");
      block = $(block);

      const stickyEffect = block.data("sticky-effect");
      if (!stickyEffect) return;

      const normalElement = box.previousElementSibling;
      if (!normalElement) return;

      const nextElement = box.nextElementSibling;
      const nextElementNext = nextElement && nextElement.nextElementSibling;

      setTimeout(() => {
        const viewportHeight = window.innerHeight;
        const sectionHeight = normalElement.offsetHeight;

        let scrollTop = 0;
        if (sectionHeight >= viewportHeight) {
          scrollTop = viewportHeight - sectionHeight;
        } else {
          scrollTop = 0;
        }

        normalElement.style.setProperty("--viewport-height", `${scrollTop}px`);
      }, 100);

      normalElement.classList.add("sticky-active");
      nextElement && nextElement.classList.add("background");
      nextElementNext && nextElementNext.classList.add("background");

      let isSticky = false;

      window.addEventListener("scroll", function () {
        const stickyTop = normalElement.getBoundingClientRect().top;
        const normalElementBottom = box.getBoundingClientRect().top;

        if (stickyTop <= 0 && !isSticky) {
          normalElement.classList.add("sticky-active");
          isSticky = true;
        }

        if (normalElementBottom <= 0 && isSticky) {
          normalElement.classList.remove("sticky-active");
          isSticky = false;
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    stickyScrollEffect();
    window.addEventListener("resize", stickyScrollEffect);
    document.addEventListener("shopify:section:load", stickyScrollEffect);
    document.addEventListener("shopify:section:unload", stickyScrollEffect);
    document.addEventListener("shopify:section:reorder", stickyScrollEffect);
  });
})();
